<div class="dialog-container">
  <div class="header">
    <h2 mat-dialog-title>Merge / Convert PDFs</h2>
    <mat-icon class="close-btn" (click)="close()">close</mat-icon>
  </div>

  <mat-dialog-content class="content-area">
    <mat-tab-group [(selectedIndex)]="selectedTab">
      
      <!-- Merge PDF Tab -->
      <mat-tab label="Merge PDF">
        <div class="tab-body">
          <p class="desc">Upload both Our PDFs and ZN PDFs to merge them into a single report.</p>
          
          <div class="upload-section">
            <label>Upload Our PDFs</label>
            <input type="file" multiple accept=".pdf" (change)="onOurPdfsSelected($event)" />
            <div class="file-list" *ngIf="ourPdfs.length">
              <span *ngFor="let f of ourPdfs">{{ f.name }}</span>
            </div>
          </div>

          <div class="upload-section mt-3">
            <label>Upload ZN PDFs</label>
            <input type="file" multiple accept=".pdf" (change)="onZnPdfsSelected($event)" />
            <div class="file-list" *ngIf="znPdfs.length">
              <span *ngFor="let f of znPdfs">{{ f.name }}</span>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Convert PDF Tab -->
      <mat-tab label="Convert PDF">
        <div class="tab-body">
          <p class="desc">Upload ZN PDFs to sort, merge, and convert them.</p>
          
          <div class="upload-section">
            <label>Upload ZN PDFs</label>
            <input type="file" multiple accept=".pdf" (change)="onZnPdfsSelected($event)" />
            <div class="file-list" *ngIf="znPdfs.length">
              <span *ngFor="let f of znPdfs">{{ f.name }}</span>
            </div>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button class="btn btn-secondary" (click)="close()">Cancel</button>
    <button class="btn btn-primary submit-btn" (click)="submit()">Submit</button>
  </mat-dialog-actions>
</div>
